import { AppState } from '../appState'
import { formatValueForDisplay } from '../lib/formattingUtils'
import HouseFallbackSVG from './HouseFallbackSVG'
import { TypographyH2, TypographyP } from './typographyComponents'

interface Props {
  appState: AppState
}

function formatMunicipality(value: string | undefined) {
  return value ? `${value} kommun` : ''
}

function ObjectSummary({ appState }: Readonly<Props>) {
  if (appState.houseObject) {
    const { image, adress, kommunBenamning, pris, boarea, avgift, drift } =
      appState.houseObject
    const diplayValueForOperatingCost =
      typeof drift === 'number'
        ? `${formatValueForDisplay(Math.round(+drift / 12))} kr/mån`
        : '-'
    const diplayValueForMonthlyFee =
      typeof avgift === 'number'
        ? `${formatValueForDisplay(Math.round(+avgift))} kr/mån`
        : '-'

    return (
      <section className="flex flex-col bg-neutral-94 lg:flex-row">
        {image ? (
          <img
            src={image}
            alt="Bild på den valda bostaden"
            className="h-full max-h-64 w-full object-cover lg:max-h-full lg:max-w-[50%]"
          />
        ) : (
          <div className="flex h-full max-h-64 w-full justify-center object-cover p-4">
            <HouseFallbackSVG />
          </div>
        )}
        <div className="mx-4 mb-4 mt-8 flex-shrink-0 flex-grow basis-[50%] lg:max-w-[calc(50%-32px)]">
          <TypographyH2
            type="display"
            className="!mb-2 !text-[32px]"
            data-cy="adress"
          >
            {adress}
          </TypographyH2>
          <TypographyP type="xl" data-cy="municipality">
            {formatMunicipality(kommunBenamning)}
          </TypographyP>
          <hr className="my-4 !border-t-0 border-b-2 !text-neutral-50" />
          <TypographyP type="xl" data-cy="starting-price">
            Utgångspris: {pris?.toLocaleString('sv-SE')} kr
          </TypographyP>
          <TypographyP type="xl" data-cy="size">
            Boarea: {boarea} m²
          </TypographyP>
          <TypographyP type="xl" data-cy="monthly-fee">
            Avgift: {diplayValueForMonthlyFee}
          </TypographyP>
          <TypographyP type="xl" data-cy="operating-cost">
            Driftkostnad: {diplayValueForOperatingCost}
          </TypographyP>
        </div>
      </section>
    )
  }
  return (
    <section className="flex flex-col justify-center bg-neutral-94">
      <div className="flex max-h-64 justify-center p-4">
        <HouseFallbackSVG />
      </div>
    </section>
  )
}

export default ObjectSummary
